<script lang="ts">
  import FailureIcon from "./assets/FailureIcon.svelte";
  import Button from "../common/Button/Button.svelte";
  import { i18n, language } from "../../i18n";
  import { getMainPageURL } from "../../handoff";

  export let kind: "brokenLink" | "setup" | "transient";
  export let disabled: boolean = false;

  $: mainPageURL = getMainPageURL($language);
</script>

<div class="Failure">
  <FailureIcon
    class="Failure__logo"
    fill={kind === "brokenLink" ? "var(--darkGrey)" : "var(--danger)"}
    width={72}
    height={72}
  />
  {#if kind === "brokenLink"}
    <h3>{$i18n.t("failure_broken_link_title")}</h3>
    <p>{$i18n.t("failure_broken_link_text")}</p>
    <!-- The widget is normally framed, so only `_top` gets the site a page. -->
    <Button href={mainPageURL} target="_top">
      {$i18n.t("failure_broken_link_button")}
    </Button>
  {:else if kind === "transient"}
    <h3>{$i18n.t("failure_transient_title")}</h3>
    <p>{$i18n.t("failure_transient_text")}</p>
    <Button {disabled} on:click>{$i18n.t("failure_transient_button")}</Button>
  {:else}
    <h3>{$i18n.t("failure_title")}</h3>
    <p>
      {$i18n.t("failure_setup_error1")}<br />
      {$i18n.t("failure_setup_error2")}
    </p>
  {/if}
</div>

<style>
  h3 {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    margin: 0;
    text-align: center;
  }

  p {
    margin: 8px 0;
    line-height: 24px;
    text-align: center;
  }

  .Failure {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 23px;
  }

  /*
   Scoped styles don't work when passed to another component
   https://github.com/sveltejs/svelte/issues/2870
  */
  :global(.Failure__logo) {
    margin-bottom: 32px;
  }
</style>
